import { useOnline } from '../hooks/useOnline';
import { useT } from '../i18n';

/**
 * Узкая жёлтая полоса в верхней части шапки, видна только при
 * `navigator.onLine === false`. Помогает оператору сразу понять, почему
 * новые сообщения не приходят: SW сейчас отдаёт cached список диалогов,
 * операции отправки будут падать.
 */
export function OfflineBanner() {
  const online = useOnline();
  const t = useT();

  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-yellow-100 text-yellow-900 text-xs text-center py-1 border-b border-yellow-300"
    >
      {t('offline.banner')}
    </div>
  );
}
